/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */
export const REQUEST_CUSTOMERS = 'REQUEST_CUSTOMERS';
export const REQUEST_CUSTOMERS_SUCCESS = 'REQUEST_CUSTOMERS_SUCCESS';
export const REQUEST_CUSTOMERS_FAILURE = 'REQUEST_CUSTOMERS_FAILURE';

export const REQUEST_CUSTOMER = 'REQUEST_CUSTOMER';
export const REQUEST_CUSTOMER_SUCCESS = 'REQUEST_CUSTOMER_SUCCESS';
export const REQUEST_CUSTOMER_FAILURE = 'REQUEST_CUSTOMER_FAILURE';

export const REQUEST_ADD_CUSTOMER = 'REQUEST_ADD_CUSTOMER';
export const REQUEST_ADD_CUSTOMER_SUCCESS = 'REQUEST_ADD_CUSTOMER_SUCCESS';
export const REQUEST_ADD_CUSTOMER_FAILURE = 'REQUEST_ADD_CUSTOMER_FAILURE';

export const REQUEST_UPDATE_CUSTOMER = 'REQUEST_UPDATE_CUSTOMER';
export const REQUEST_UPDATE_CUSTOMER_SUCCESS = 'REQUEST_UPDATE_CUSTOMER_SUCCESS';
export const REQUEST_UPDATE_CUSTOMER_FAILURE = 'REQUEST_UPDATE_CUSTOMER_FAILURE';

export const REQUEST_DELETE_CUSTOMER = 'REQUEST_DELETE_CUSTOMER';
export const REQUEST_DELETE_CUSTOMER_SUCCESS = 'REQUEST_DELETE_CUSTOMER_SUCCESS';
export const REQUEST_DELETE_CUSTOMER_FAILURE = 'REQUEST_DELETE_CUSTOMER_FAILURE';

export const REQUEST_NAME_CUSTOMER = 'REQUEST_NAME_CUSTOMER';
export const REQUEST_NAME_CUSTOMER_FAILURE = 'REQUEST_NAME_CUSTOMER_FAILURE';
export const REQUEST_NAME_CUSTOMER_SUCCESS = 'REQUEST_NAME_CUSTOMER_SUCCESS';

